import { tutorials } from '@/mocks/homeData';
import SectionHeading from './SectionHeading';

export default function Tutorials() {
  return (
    <section id="tutorials" className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <SectionHeading
            eyebrow="使用教程 · 封面精选"
            title="黑料导航使用教程，按主题挑一篇看"
            desc="教程按新手指引、功能技巧、问题排查等方向整理，篇幅短、步骤清楚，对照操作即可。"
          />
          <a
            href="#faq"
            className="inline-flex items-center gap-1.5 text-sm text-primary-700 hover:text-primary-800 cursor-pointer whitespace-nowrap"
          >
            还有疑问？看常见问题
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {tutorials.map((item) => (
            <article
              key={item.id}
              className="group flex flex-col bg-background-100 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-colors"
            >
              <div className="relative w-full h-44 md:h-48 overflow-hidden">
                <img
                  src={item.cover}
                  alt={`${item.title} 教程封面`}
                  title={`${item.title} 使用教程`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-secondary-500/95 text-background-50 text-xs whitespace-nowrap">
                  {item.category}
                </span>
              </div>
              <div className="flex flex-col flex-1 p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg text-foreground-950 leading-snug group-hover:text-primary-700 transition-colors">
                  {item.title}
                </h3>
                <div className="mt-3 flex items-center gap-4 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {item.readTime}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                </div>
                <div className="mt-4 pt-4 border-t border-background-200 flex items-center justify-between">
                  <span className="text-sm text-foreground-700 inline-flex items-center gap-1.5">
                    <i className="ri-book-open-line text-accent-600"></i>
                    阅读教程
                  </span>
                  <span className="w-8 h-8 rounded-md bg-primary-100 text-primary-700 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}